import BreadcrumbList from '../../Stock/components/Breadcrumb';
import { Button, Card, DatePicker, Menu, Table } from 'antd';
import useDebounce from '@root/core/hooks/useDebounce';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import ReturnServices from '@root/modules/Sellers/Return/services/return';
import { ColumnsType } from 'antd/lib/table';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import DropdownButton from '../../Inquiry/components/DropdownButton';
import SearchBox from '../../Inquiry/components/Search';
import useTranslate from '@root/core/hooks/useTranslate';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { ProcessType, ReturnStatus, ReturnStatusLabel, ReturnType, WarehouseReturnStatus, WarehouseReturnStatusLabel } from '../enum';
import Excel from '@root/utils/helpers/excel';
import { IFilter } from '../../Product/interfaces';

interface DataType {
  key: React.Key;
  no: number;
  orderNumber: string;
  buyerName: string;
  productName: string;
  warehouseName: string;
  status: string;
  updated_at: Date;
  setSelectedRow: React.Dispatch<React.SetStateAction<React.Key[]>>;
}

const ShippingReturnRequest = () => {
  const [t] = useTranslate();
  const [list, setList] = useState([] as any);
  const history = useHistory();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItem, setTotaItem] = useState(0);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [returnStatus, setReturnStatus] = useState({
    value: '',
    label: t('seller:button:select')
  });
  const [warehouseReturnStatus, setWarehouseReturnStatus] = useState({
    value: '',
    label: t('seller:button:select')
  });
  const [fieldSearch, setFieldSearch] = useState({
    value: '',
    label: t('seller:button:select')
  });
  const [valueSearch, setValueSearch] = useState('');
  const debounc = useDebounce(valueSearch, 1000);
  const [sortBy, setSortBy] = useState('updated_at:DESC');

  const [dateValue, setDateValue] = useState<[string, string]>();
  const fromDt: string = (dateValue && dateValue[0]) || '';
  const toDt: string = (dateValue && dateValue[1]) || '';
  const listBreadcrumb = [
    {
      tittle: '배송 관리',
      url: ''
    },
    {
      tittle: '반품 조회',
      url: ''
    }
  ];
  const columns: ColumnsType<DataType> = [
    {
      title: 'No',
      dataIndex: 'key'
    },
    {
      title: '상품명',
      dataIndex: 'productName'
    },
    {
      title: 'SKU',
      dataIndex: 'sku'
    },
    {
      title: '물류센터명',
      dataIndex: 'warehouseName'
    },
    {
      title: '반품상태',
      dataIndex: 'returnStatus'
    },
    {
      title: '검수상태',
      dataIndex: 'inspectionStatus'
    },
    {
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          업데이트일
          {sortBy === 'updated_at:DESC' ? (
            <DownOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => {
                setSortBy('updated_at:ASC');
              }}
            />
          ) : (
            <UpOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => setSortBy('updated_at:DESC')}
            />
          )}
        </div>
      ),
      dataIndex: 'updated_at'
    }
  ];

  const { RangePicker } = DatePicker;
  const dateFormat = 'YYYY.MM.DD';
  const getFilter = (): IFilter => {
    return {
      type: ProcessType.Return,
      returnType: ReturnType.Order,
      status: returnStatus.value,
      warehouseReturnStatus: warehouseReturnStatus.value,
      [fieldSearch.value]: valueSearch,
      from: fromDt,
      to: toDt
    }
  }
  const getPagination = async (page: number) => {
    setLoading(true);
    try {
      const result = await ReturnServices.searchReturns({
        page,
        sortBy,
        filter: getFilter(),
      });
      const list = (result.data ?? []).map((item: any, index: number) => {
        return {
          ...item,
          no: index + 1,
          key: item.returnId,
          updated_at: formatDateTime(item.updatedAt),
          productName: item?.productName,
          sku: item?.productSku,
          warehouseName: item?.warehouseName,
          returnStatus: ReturnStatusLabel[item.status as ReturnStatus],
          inspectionStatus: WarehouseReturnStatusLabel[item.warehouseReturnStatus as WarehouseReturnStatus],
        };
      });

      setList(list);
      setTotalPages(result?.meta?.totalPages ?? 0);
      setCurrentPage(result?.meta?.currentPage ?? 1);
      setTotaItem(result?.meta?.totalItems ?? 0);
      setLoading(false);
    } catch (e) {
      setList([]);
      setTotalPages(0);
      setCurrentPage(1);
      setTotaItem(0);
      setLoading(false);
    }
  };

  useEffect(() => {
    getPagination(1);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounc, returnStatus, warehouseReturnStatus, fieldSearch, sortBy, fromDt, toDt]);

  const handelExportExcel = async () => {
    const excelOption = {
      blod: undefined,
      fileName: 'DeliveryReturnRequest'
    };

    excelOption.blod = await ReturnServices.returnExportExcel({
      sortBy,
      filter: getFilter(),
      listId: selectedRowKeys.map((item) => Number(item))
    });

    Excel.download(excelOption)
  };

  const listLabel = [
    {
      id: 1,
      label: returnStatus.label,
      title: '반품상태',
      listMenu: (
        <Menu
          onClick={(e: any) => setReturnStatus({ value: e.key, label: e.domEvent.target.innerText })}
          items={[
            {
              label: ReturnStatusLabel[ReturnStatus.Request],
              key: ReturnStatus.Request,
            },
            {
              label: ReturnStatusLabel[ReturnStatus.Inprogress],
              key: ReturnStatus.Inprogress,
            },
            {
              label: ReturnStatusLabel[ReturnStatus.Completed],
              key: ReturnStatus.Completed,
            }
          ]}
        />
      )
    },
    {
      id: 2,
      label: warehouseReturnStatus.label,
      title: '검수상태',
      listMenu: (
        <Menu
          onClick={(e: any) => setWarehouseReturnStatus({ value: e.key, label: e.domEvent.target.innerText })}
          items={[
            {
              label: WarehouseReturnStatusLabel[WarehouseReturnStatus.Request],
              key: WarehouseReturnStatus.Request,
            },
            {
              label: WarehouseReturnStatusLabel[WarehouseReturnStatus.Inprogress],
              key: WarehouseReturnStatus.Inprogress,
            },
            {
              label: WarehouseReturnStatusLabel[WarehouseReturnStatus.Complete],
              key: WarehouseReturnStatus.Complete,
            }
          ]}
        />
      )
    },
    {
      id: 3,
      label: fieldSearch.label,
      listMenu: (
        <Menu
          onClick={(e: any) => setFieldSearch({ value: e.key, label: e.domEvent.target.innerText })}
          items={[
            {
              label: '상품명',
              key: 'productName',
            },
            {
              label: 'SKU',
              key: 'sku',
            },
            {
              label: '물류센터명',
              key: 'warehouseName',
            }
          ]}
        />
      )
    }, 
  ];

  const rowSelection = {
    selectedRowKeys,
    preserveSelectedRowKeys: true,
    onChange: (selectedRowKeyss: React.Key[], selectedRows: DataType[]) => {
      setSelectedRowKeys(selectedRowKeyss);
    },
    getCheckboxProps: (record: DataType) => ({
      name: record.productName
    })
  };

  return (
    <>
      <BreadcrumbList listBreadcrumb={listBreadcrumb} />
      <div className="admin-container">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          {' '}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          ></div>
          <div className="control">
            <RangePicker
              style={{minWidth: '250px'}}
              onChange={(date: any, dateString: [string, string]) => {
                setDateValue(dateString);
              }}
              placeholder={['YYYY.MM.DD', 'YYYY.MM.DD']}
              format={dateFormat}
            />
            {listLabel.map((item) => {
              return (
                <>
                  <DropdownButton
                    key={item.id}
                    label={item.label}
                    title={item.title}
                    menu={item.listMenu}
                  />
                </>
              );
            })}
            <SearchBox
              type
              onChange={(e: any) =>
                setValueSearch(e.target.value)
              }
            />
          </div>
          <div className="table">
            <div>
              <div
                style={{
                  marginBottom: 16,
                  display: 'flex',
                  justifyContent: 'space-between',
                  paddingTop: 16
                }}
              >
                <div className="table__head">
                  <span style={{ marginLeft: 8 }}>총 배송 {totalItem}</span>
                  <span className="table__head --right">
                    선택 반품 {selectedRowKeys.length}
                  </span>
                </div>

                <div>
                  <Button
                    className="downExcel"
                    onClick={handelExportExcel}
                  >
                    {t('common:download')}
                  </Button>
                </div>
              </div>
              <Table
                loading={loading}
                columns={columns}
                dataSource={list}
                rowSelection={rowSelection}
                pagination={{
                  total: totalPages * 10,
                  current: currentPage,
                  showSizeChanger: false,
                  onChange: (page) => {
                    getPagination(page);
                  }
                }}
                onRow={(item) => {
                  return {
                    onClick: () => {
                      history.push(`/admin/seller/shipping/return-request/${item.key}`);
                    }
                  };
                }}
              />
            </div>
          </div>
        </Card>
      </div>
    </>
  );
};

export default ShippingReturnRequest;
